import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { initPaciente, initConsultaData, clearPaciente } from "../../redux/slices/consulta";

import { usePacienteConsultaData } from './hooks/usePacienteConsultaData';
import { usePacienteConsultaDiagnosticos } from './hooks/usePacienteConsultaDiagnosticos';

import { Error, Forbidden, Loader } from '../../components';
import { Radiologia } from './components/Radiologia';
import { Laboratorio } from './components/Laboratorio';
import { PruebaAlergia } from './components/PruebaAlergia';
import { Inmunoterapia } from './components/Inmunoterapia';
import { Consulta } from './components/Consulta';

import styles from './PacienteConsulta.module.css';

export const PacienteConsulta = () => {

  const dispatch = useDispatch();

  const { id } = useParams();

  const consultaFinalizadaRef = useRef(null);

  const { permisos } = useSelector(state => state.auth);

  const dataConsultaBrowser = useSelector(state => state.consulta[id]);

  const consultaInicializada = dataConsultaBrowser?.inicializado === true;

  let defaultTab = 5;

  if(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete){
    defaultTab = 1;
  }else if(permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate){
    defaultTab = 2;
  }else if(permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate){
    defaultTab = 3;
  }else if(permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate){
    defaultTab = 4;
  }

  const [tab, setTab] = useState(defaultTab);

  const { pacienteConsultaDataQuery: { isLoading, isError, data: dataConsulta, refetch: refetchDataConsulta } } = usePacienteConsultaData(id);
  const { pacienteConsultaDiagnosticosQuery: { isLoading: isLoadingDiagnosticos, isError: isErrorDiagnosticos, data: dataDiagnosticos } } = usePacienteConsultaDiagnosticos();

  const handleFinalizarConsulta = () => {

    consultaFinalizadaRef.current = id;

    dispatch(clearPaciente(id));

  };

  useEffect(() => {

    if (!id || consultaFinalizadaRef.current === id) {

        return;

    }

    dispatch(initPaciente({ id }));

    if (dataConsulta) {

        dispatch(initConsultaData({ id, data: dataConsulta }));

    }

  }, [dispatch, id, dataConsulta]);

  const consultaLista = (!isLoading && !isLoadingDiagnosticos && consultaInicializada);

  return (
    <>
      <div className="row">
        {(permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate) &&
          <div className="col-sm-12 col-md-7">
            {!consultaLista
              ? ((isError || isErrorDiagnosticos)
                ? <Error />
                : <Loader />
              )
              : (
                <>
                  {(isError || isErrorDiagnosticos)
                    ? <Error />
                    : (
                      <Consulta
                        data={dataConsultaBrowser}
                        dataMigrada={dataConsulta?.migrada ?? false}
                        dataDiagnosticos={dataDiagnosticos}
                        refetchDataConsulta={refetchDataConsulta}
                        onFinalizarConsulta={handleFinalizarConsulta}
                      />
                    )
                  }
                </>
              )
            }
          </div>
        }
        <div className={(permisos.consultaRead || permisos.consultaCreate || permisos.consultaUpdate) ? "col-sm-12 col-md-5" : "col mt-2"}>
          <div className={styles.tabsContainer}>
            <div className="row">
              {(permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) &&
                <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + (tab === 1 ? styles.tabInmunoterapiasActive : styles.tabInmunoterapias)} onClick={() => setTab(1)}></div>
                </div>
              }
              {(permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate) &&
                <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + (tab === 2 ? styles.tabPruebasActive : styles.tabPruebas)} onClick={() => setTab(2)}></div>
                </div>
              }
              {(permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate) &&
                <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + (tab === 3 ? styles.tabLaboratoriosActive : styles.tabLaboratorios)} onClick={() => setTab(3)}></div>
                </div>
              }
              {(permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate) &&
                <div className={"col p-0 " + styles.tabContainer}>
                  <div className={styles.tab + " " + (tab === 4 ? styles.tabRadiologiaActive : styles.tabRadiologia)} onClick={() => setTab(4)}></div>
                </div>
              }
            </div>
            <div className="row">
              <div className="col">
                <hr />
              </div>
            </div>
            <div className="row">
              {((permisos.inmunoterapiaRead || permisos.inmunoterapiaCreate || permisos.inmunoterapiaUpdate || permisos.inmunoterapiaDelete) && tab === 1) &&
                <div className="col">
                  <Inmunoterapia />
                </div>
              }
              {((permisos.pruebaAlergiaRead || permisos.pruebaAlergiaCreate || permisos.pruebaAlergiaUpdate) && tab === 2) &&
                <div className="col">
                  <PruebaAlergia />
                </div>
              }
              {((permisos.laboratorioRead || permisos.laboratorioCreate || permisos.laboratorioUpdate) && tab === 3) &&
                <div className="col">
                  <Laboratorio />
                </div>
              }
              {((permisos.radiologiaRead || permisos.radiologiaCreate || permisos.radiologiaUpdate) && tab === 4) &&
                <div className="col">
                  <Radiologia />
                </div>
              }
              {tab === 5 &&
                <div className="col">
                  <Forbidden />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )

}
